module.exports = __webpack_public_path__ + "img/silder_04.576224b4.jpg";